module.exports = __webpack_public_path__ + "assets/img/report-act-bg-5.eecd4d6b.png";